import Routes from "@const/routes";

let scrollPosition = window.pageYOffset;

const checkOverflow = () => {
  return document.body.scrollHeight > window.innerHeight;
};

const getScrollbarWidth = () => {
  // Creating invisible container
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";

  // Forcing scrollbar to appear
  outer.style.overflow = "scroll";
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement("div");
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer.parentNode?.removeChild(outer);

  return scrollbarWidth;
};

const applyPadding = (padding) => {
  document.body.style.setProperty("padding-right", `${padding}px`, "important");
};

const routesWithoutPadding = [Routes.STREAM()];

export const updateWindowPadding = () => {
  if (
    routesWithoutPadding.some((route) =>
      window.location.pathname.includes(route),
    )
  ) {
    applyPadding(0);
    return;
  }

  const scrollbarWidth = getScrollbarWidth();
  // save scroll when modal opens
  scrollPosition = window.pageYOffset;
  if (document.querySelector("body.modal-open")) {
    applyPadding(scrollbarWidth);
    return;
  }
  // restore scroll after modal closes
  void window.scrollTo(0, scrollPosition);
  const isOverflowing = checkOverflow();
  applyPadding(isOverflowing ? 0 : scrollbarWidth);
};

const setResizeEventListener = () => {
  // set initial scrollbar width
  const scrollbarWidth = getScrollbarWidth();
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${scrollbarWidth}px`,
  );

  const iframe = document.createElement("iframe");
  iframe.title = "resize-listener";
  iframe.id = "scrollbar-resize-listener";
  iframe.style.cssText =
    "height: 0; background-color: transparent; margin: 0; padding: 0; overflow: hidden; border-width: 0; position: absolute; width: 100%;";

  // Register our event when the iframe loads
  iframe.onload = function () {
    // The trick here is that because this iframe has 100% width
    // it should fire a window resize event when anything causes it to
    // resize (even scrollbars on the outer document)
    iframe.contentWindow.addEventListener("resize", updateWindowPadding);
  };

  // Stick the iframe somewhere out of the way
  document.body.appendChild(iframe);
};

window.addEventListener("DOMContentLoaded", setResizeEventListener);
